import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_5 = { class: "relative w-full overflow-hidden text-left transition-all transform bg-white rounded shadow sm:my-8 sm:w-full sm:max-w-lg" }
const _hoisted_6 = { class: "bg-white" }
const _hoisted_7 = { class: "flex items-center justify-between border-b border-gray-400" }
const _hoisted_8 = { class: "w-full px-2 py-4 text-left" }
const _hoisted_9 = {
  class: "text-lg font-medium leading-6 text-gray-900",
  id: "modal-title"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onSubmit"]
const _hoisted_13 = { class: "space-y-2.5 mt-4" }
const _hoisted_14 = {
  for: "org-name",
  class: "mt-4"
}
const _hoisted_15 = { class: "flex justify-center px-4 py-3 bg-gray-50 mt-4" }

import { ref, watch } from "vue";
import DefaultButton from "../DefaultButton.vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditOrganisationNameModal',
  props: {
  isOpen: {
    type: Boolean,
    required: true,
  },
  organisationName: {
    type: String,
    default: "",
  },
  isSaving: {
    type: Boolean,
    default: false,
  },
},
  emits: ["close", "save"],
  setup(__props, { emit: emits }) {

const props = __props;

const { t: $t } = useI18n();




const name = ref(props.organisationName);

watch(
  () => props.organisationName,
  (val) => {
    name.value = val;
  }
);

function save() {
  emits("save", name.value);
}

function close() {
  emits("close");
}

return (_ctx: any,_cache: any) => {
  return (props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref($t)("edit-organisation-name")), 1)
                  ]),
                  _createElementVNode("div", { class: "py-4 pl-2 pr-4" }, [
                    _createElementVNode("button", { onClick: close }, _hoisted_11)
                  ])
                ]),
                _createElementVNode("form", {
                  class: "px-4 pb-8 mt-4 border-b border-gray-400",
                  onSubmit: _withModifiers(save, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_unref($t)("name")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "org-name",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                      class: "text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
                      required: ""
                    }, null, 512), [
                      [_vModelText, name.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(DefaultButton, {
                      type: "primary",
                      "is-form-submit": true,
                      disabled: props.isSaving
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($t)("save")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ], 40, _hoisted_12)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})